var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth2-redirect"},[_vm._v(" Authentication Success ")])
}
var staticRenderFns = []

export { render, staticRenderFns }